import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    failureDetailsSelectionContainer: {
        color: theme.palette.primary.dark,
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
    },
    selectionContainer: {
        padding: `${theme.spacing(2.5)} !important`,
        background: `${theme.palette.text.primary} !important`,
        color: `${theme.palette.primary.main} !important`,
        textTransform: "capitalize",
        borderRadius: 4,
        minWidth: `130px !important`,
    },
    buttonBox: {
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(2),
    },
    buttonText: {
        textTransform: "capitalize",
    },
    title: {
        marginBottom: `${theme.spacing(1)} !important`,
        fontSize: "11px !important",
    },
}));
